import { Box, Button, Container, Grid } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import { useContext, useEffect, useState, useRef } from 'react';
import { CreateAddonValidationSchema } from '../../utils/Validations';
import { patchRequestWithToken, postRequest } from '../../utils/ApiRequests';
import { GlobalContext } from '../../components/GlobalStateProvide/GlobalStateProvider';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import FocusError from '../../components/FocusError/FocusError';
import ReusableLoader from "../../components/ReusableLoader/ReusableLoader";
import BackBtn from '../../components/backButton/BackBtn';
import { checkPermission } from '../../utils/userPermissions'
import Unauthorized from "../../components/unauthorized/Unauthorized";
import CircularProgress from '@mui/material/CircularProgress';
import RichTextEditor from 'react-rte';

const CreateAddon = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const { handleSnackBar } = useContext(GlobalContext);
  const location = useLocation();

  const [dataById, setDataById] = useState([]);
  const [showLoader, setShowLoader] = useState(false);

  const [canCreate, setCanCreate] = useState(true);
  const [canDelete, setCanDelete] = useState(true);
  const [canUpdate, setCanUpdate] = useState(true);
  const [canRead, setCanRead] = useState(true);
  const [isAccess, setisAccess] = useState([]);
  const [jobCount, setJobCount] = useState(0);
  const [isIncludesValue, setisIncludesValue] = useState(true);
  const [contentError, setContentError] = useState(false);

  const [sector, setSector] = useState([]);
  // const [fetchingPincode, setfetchingPincode] = useState(false);
  const [editorValue, setEditorValue] = useState(RichTextEditor.createEmptyValue());


  const [initialValues, setInitialValues] = useState({
    amount: "",
    hcCredit: "",
    extraCredit: "",
    discountPercentage: "",
    addonPackName: "",
    expiryDuration: "",


  })
  const [edit, setEdit] = useState(false);

  // console.log(location, "this is location");


  const scrollTargetRef = useRef(null);
  const navigate = useNavigate();

  const handleSubmit = async (values, { resetForm }) => {


    setContentError(false);
    setFormSubmitted(true);
    let formData = edit ? {
      amount: values.amount,
      hcCredit: values.hcCredit,
      extraCredit: values.extraCredit,
      discountPercentage: values.discountPercentage,
      addonPackName: values.addonPackName,
      expiryDuration: values.expiryDuration,

    } : {

      amount: values.amount,
      hcCredit: values.hcCredit,
      extraCredit: values.extraCredit,
      discountPercentage: values.discountPercentage,
      addonPackName: values.addonPackName,
      expiryDuration: values.expiryDuration,

    }


    try {
      let res = edit ?
        await patchRequestWithToken(`admin/addon/${dataById._id}`, formData) : await postRequest('admin/addon', formData);
      if (res.data.status === 'Success') {
        setFormSubmitted(false);
        if (!edit) {
          resetForm();

          handleSnackBar(true, res.data.msg, "success");
          setTimeout(() => {
            navigate('/addon');
          }, 1000);
        }
        else {
          handleSnackBar(true, res.data.msg, "success");
          setTimeout(() => {
            navigate('/addon ');
          }, 1000);
        }
      }
      else {
        setFormSubmitted(false);
        handleSnackBar(true, res.data.msg, "error")
      }
    } catch (err) {
      console.log(err);
      setFormSubmitted(false);
      handleSnackBar(true, err?.response?.data?.msg, "error")
    }
  }



  const getEmployerById = async () => {
    console.log("location : ", location.state);
    setDataById(location.state)
  }

  const checkPermissionFunc = () => {
    const resourceToUpdate = "HC-Addon";
    const permissions = checkPermission(resourceToUpdate);
    setCanCreate(permissions.canCreate)
    setCanDelete(permissions.canDelete)
    setCanUpdate(permissions.canUpdate)
    setCanRead(permissions.canRead)
  }

  const againCheckPermissions = () => {
    // console.log("hello")
    const checkAccesInArray = localStorage.getItem("resourceNames");
    // console.log("resourceNames : " + checkAccesInArray);
    setisAccess(checkAccesInArray);
    isIncludes();
  }

  const isIncludes = () => {
    setisIncludesValue(isAccess.includes("HC-Addon"))
  }


  useEffect(() => {

    checkPermissionFunc();
    againCheckPermissions();
    if (location.state?._id) {
      getEmployerById()
    }
    else {
      setShowLoader(false);
    }

    if (location?.state?._id) {
      const { employer = {} } = dataById;

      const {
        amount = dataById?.amount,
        hcCredit = dataById?.hcCredit,
        extraCredit = dataById?.extraCredit,
        discountPercentage = dataById?.discountPercentage,
        addonPackName = dataById?.addonPackName,
        expiryDuration = dataById?.expiryDuration,

      } = employer;

      setInitialValues({
        amount,
        hcCredit,
        extraCredit,
        discountPercentage,
        addonPackName,
        expiryDuration
      });
      setEdit(true);
    } else {
      setInitialValues({
        amount: "",
        hcCredit: "",
        extraCredit: "",
        discountPercentage: "",
        addonPackName: "",
        expiryDuration: "",
      });
      setEdit(false);
    }
  }, [location.state, dataById._id, isIncludesValue, sector])




  return (
    (isIncludesValue) ? <>
      {showLoader ? <ReusableLoader /> : <Box className="create-employer-section" ref={scrollTargetRef}>

        <Container>

          <Box className="create-employer">
            <Box className="headingPlusBackBtn">
              <BackBtn />
              <h1 className='formHeadings'>{edit ? "Update Addon" : "Create Addon"}</h1>
            </Box>
            <Box className="create-employer-form-wrapper">
              <Formik
                initialValues={initialValues}
                validationSchema={CreateAddonValidationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({ errors, values, setFieldValue, resetForm }) => (

                  <Form className="create-employer-form ">

                    <Box className="backgroundStyle">

                      <Grid container spacing={2} className='cstmFormGridEmployer'>




                        <Grid item xs={12} sm={12} md={8}>
                          <Box className="form-control" >
                            <label className="form-label" htmlFor="addonPackName"> Pack Name <span className='must-fill-fields'>*</span></label>
                            <Field id="addonPackName"
                              type="text" placeholder="Enter Pack Name"
                              name="addonPackName"
                              className="form-input" size="small"
                            />
                            {errors.addonPackName && <Box className="form-error">{errors.addonPackName}</Box>}

                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={12} md={8}>
                          <Box className="form-control" >
                            <label className="form-label" htmlFor="amount"> Amount <span className='must-fill-fields'>*</span></label>
                            <Field id="amount"
                              type="text" placeholder="Enter Amount"
                              name="amount"
                              className="form-input" size="small"
                            />
                            {errors.amount && <Box className="form-error">{errors.amount}</Box>}

                          </Box>
                        </Grid>

                        <Grid item xs={12} ssm={12} md={8}>
                          <Box className="form-control">
                            <label className="form-label" htmlFor="hcCredit"> Hiring Credits<span className='must-fill-fields'>*</span></label>
                            <Field id="hcCredit"
                              type="text" placeholder="Enter Hiring credits"
                              name="hcCredit"
                              className="form-input" />
                            {errors.hcCredit && <Box className="form-error">{errors.hcCredit}</Box>}
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={12} md={8} >
                          <Box className="form-control">
                            <label className="form-label" htmlFor="extraCredit">Extra Credit <span className='must-fill-fields'>*</span></label>
                            <Field id="extraCredit"
                              type="text" placeholder="Enter extra credits"
                              name="extraCredit"
                              className="form-input" />
                            {errors.extraCredit && <Box className="form-error">{errors.extraCredit}</Box>}
                          </Box>
                        </Grid>


                        <Grid item xs={12} sm={12} md={8} >
                          <Box className="form-control">
                            <label className="form-label" htmlFor="discountPercentage">Discount %<span className='must-fill-fields'>*</span></label>
                            <Field id="discountPercentage"
                              type="text" placeholder="Discount Percentage"
                              name="discountPercentage"
                              className="form-input"

                            />
                            {errors.discountPercentage && <Box className="form-error">{errors.discountPercentage}</Box>}
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={12} md={8} >
                          <Box className="form-control">
                            <label className="form-label" htmlFor="expiryDuration">Expiry Duration<span className='must-fill-fields'>*</span></label>
                            <Field id="expiryDuration"
                              type="text" placeholder="Expiry Duration"
                              name="expiryDuration"
                              className="form-input"

                            />
                            {errors.expiryDuration && <Box className="form-error">{errors.expiryDuration}</Box>}
                          </Box>
                        </Grid>

                      </Grid>

                    </Box>

                    <Box className="form-button-section">
                      <Link to='/addon'>
                        <Button className="form-button"
                          variant="contained"
                          onClick={() => {
                            resetForm();
                          }}
                          color="error"
                        >Cancel</Button>
                      </Link>

                      <Button className="form-button"
                        variant="contained"
                        type="submit"
                        color="success"
                        disabled={formSubmitted}
                      >
                        {formSubmitted ? <CircularProgress size={24} /> :
                          edit ? "Update" : "Create"}
                      </Button>

                    </Box>
                    <FocusError handleSnackBar={handleSnackBar} />
                  </Form>
                )}
              </Formik>
            </Box>
          </Box>
        </Container>

      </Box >}
    </> : (<Unauthorized />)

  )

}
export default CreateAddon;